class ProductIngredients extends HTMLElement {
  constructor() {
    super();

    this.selectedTitle = this.querySelector("[data-ingredient-selected-title]");
    this.selectedContent = this.querySelector(
      "[data-ingredient-selected-content]"
    );
    this.ingredientList = this.querySelector("[data-ingredient-list]");

    if (!this.ingredientList) {
      return;
    }

    this.cfm_options = {
      clientName: "gisou",
      bearerToken:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MGRlMTAxYzI1ODg2NTAwMjJhZjM5MjAiLCJjbGllbnRuYW1lIjoiZ2lzb3UiLCJ1c2VybmFtZSI6Imdpc291IiwicGFzc3dvcmQiOiIkMmEkMTAkMWdnRGNXNmsxNU1HNUovRVhqb0p5T1dpM3AzODRlT095NUEzSXBzSDBCckJ0ZGpFNVlzcU8iLCJlbWFpbCI6Im5vdXJlZW4rZ2lzb3VAY2xlYXJmb3JtZS5jb20iLCJpc0FkbWluIjp0cnVlLCJzdXBlckFkbWluIjpmYWxzZSwicGFja2FnZSI6InBybyBicmFuZCIsInBlcm1pc3Npb24iOiJvd25lciIsImlhdCI6MTYyNTE2NjY0OH0.p3gPydbAz933JVTiiRMuzN4QpW5jegMTrvx12u0E4pQ",
      sku: this.getAttribute("data-selected-sku"),
    };

    this.initCfm();
  }

  initCfm() {
    const url =
      "https://server.clearforme.com/api/app/products/details?sku=" +
      this.cfm_options.sku +
      "&clientname=" +
      this.cfm_options.clientName;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: this.cfm_options.bearerToken,
      },
    })
      .then((res) => res.json())
      .then((response) => {
        let ingListStr = "";
        if (!response.productIngredients) {
          return;
        }
        response.productIngredients.forEach((pIngredients) => {
          pIngredients.functionGroup.forEach((fGroup) => {
            fGroup.ingredients.forEach((ingredient, idx) => {
              ingListStr += `<span class="${
                idx == 0 ? "active" : ""
              }" data-ingredient="${ingredient.ingredientName}">${
                ingredient.ingredientName
              }</span>, `;
              if (idx == 0) {
                this.getIngItem(ingredient.ingredientName);
              }
            });
          });
        });
        ingListStr = ingListStr.slice(0, -2);
        this.ingredientList.innerHTML = ingListStr;
        this.ingredientList.querySelectorAll(`span`).forEach((ingBtn) => {
          ingBtn.addEventListener("click", () => {
            this.getIngItem(ingBtn.getAttribute("data-ingredient"));
            this.ingredientList
              .querySelector(`span.active`)
              .classList.remove("active");

            ingBtn.classList.add("active");
          });
        });
      });
  }

  getIngItem(ingredientName) {
    const url =
      "https://server.clearforme.com/api/app/ingredients/definition?sku=" +
      this.cfm_options.sku +
      "&ingredientName=" +
      ingredientName +
      "&clientname=" +
      this.cfm_options.clientName;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: this.cfm_options.bearerToken,
      },
    })
      .then((res) => res.json())
      .then((response) => {
        this.selectedTitle.innerHTML = ingredientName;
        this.selectedContent.innerHTML = response.definition;
      });
  }
}

customElements.define("product-ingredients", ProductIngredients);